import { BankJourneyConfig } from './bank-config';
import { EligibilityJourneyConfig } from './eligibility-config';
import { ExtraBboxJourneyConfig } from './extra-bbox-config';
import { GamingJourneyConfig } from './gaming-config';
import { LmJourneyConfig } from './lm-config';
import { MixedCartJourneyConfig } from './mixed-cart-config';
import { PromoJourneyConfig } from './promo-config';
import { PromoPriveeJourneyConfig } from './promo-privee-config';
import { SmartTvJourneyConfig } from './smart-tv-config';
import { TabletJourneyConfig } from './tablet-config';
import { YoungJourneyConfig } from './young-config';

export type JourneyConfigType = ReturnType<EligibilityJourneyConfig['getConfig']>;

export const configMapping: Record<string, new () => EligibilityJourneyConfig> = {
    'test-eligibilite': EligibilityJourneyConfig,
    'test-eligibilite-panier-mixte': MixedCartJourneyConfig,
    'test-eligibilite-smart-tv': SmartTvJourneyConfig,
    'test-eligibilite-gaming': GamingJourneyConfig,
    'test-eligibilite-tablette': TabletJourneyConfig,
    'test-eligibilite-moins-26-ans': YoungJourneyConfig,
    'test-eligibilite-bboxbanque': BankJourneyConfig,
    'test-eligibilite-promo': PromoJourneyConfig,
    'test-eligibilite-promo-privee': PromoPriveeJourneyConfig,
    'test-eligibilite-bbox-extra': ExtraBboxJourneyConfig,
    'test-eligibilite-bbox-lm': LmJourneyConfig,
};

export function getConfigBySlug(journey: string): JourneyConfigType {
    // Get the config class from the mapping
    const ConfigClass = configMapping[journey];

    // If no class was found for the given slug, throw an error
    if (!ConfigClass) {
        throw new Error(`No config found for slug "${journey}"`);
    }

    // Instantiate the config class and return its config
    return new ConfigClass().getConfig();
}
